import { AppointmentStatus } from '@appointments/enums/appointment-status.enum';
import { ListingActivityConstants } from '@listings/constants/listing-activity-constants';
import { OutboundInquiryEventSource } from 'app/graphql/graphql';

export const FUB_LISTING_ACTIVITY_EVENT_SOURCE_MAP = new Map<number, OutboundInquiryEventSource>([
    [ListingActivityConstants.Liked.id, OutboundInquiryEventSource.Liked],
    [ListingActivityConstants.Disliked.id, OutboundInquiryEventSource.Disliked],
    [ListingActivityConstants.Shown.id, OutboundInquiryEventSource.Shown],
]);

export const FUB_APPOINTMENT_STATUS_EVENT_SOURCE_MAP = new Map<AppointmentStatus, OutboundInquiryEventSource>([
    [AppointmentStatus.Confirmed, OutboundInquiryEventSource.AppointmentConfirmed],
    [AppointmentStatus.Declined, OutboundInquiryEventSource.AppointmentDeclined],
]);
